export const MONTHLY_PLAN_IDS = [
  'pro.1m',
  'pro.1m_29_99',
  'pro.1m_59_99',
  'pro.1m_79_99',
  'pro.1m_99_99',
  'pro.rebill_1m_discount',
  'pro.rebill_month_29_99',
  'pro.rebill_month_29_99_to_39_99',
  'pro.rebill_month_49_99',
  'pro.rebill_2weeks_39_99',
] as const;

export const WEEKLY_PLAN_IDS = [
  'pro.1w',
  'pro.1w_19_99',
  'pro.1w_39_99',
  'pro.rebill_1w_discount',
  'pro.rebill_1w_discount_9_99',
  'pro.rebill_week_19_99',
  'pro.rebill_week_9_99_to_21_99',
  'pro.rebill_week_14_99_to_29_99',
] as const;

export const THREE_MONTHS_PLAN_IDS = [
  'pro.3m',
  'pro.3m_119_99',
  'pro.rebill_3m_discount',
  'pro.rebill_3months_59_99',
  'pro.rebill_3months_59_99_to_79_99',
] as const;

export const YEARLY_PLAN_IDS = ['pro.1y'] as const;

export const ONE_OFF_PLAN_IDS = [
  'pro.one_off_1d_9_99',
  'pro.one_off_1d_14_99',
  'pro.one_off_1d_19_99',
] as const;

export function isRebillStripePlanId(planId: string): boolean {
  return planId.includes('rebill');
}
